var _excluded = ["children", "className", "value", "itemText", "onClick", "onKeyPress", "href", "dropdownKind", "index", "iconName", "iconType", "fieldID", "disabled"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Icon from '../Icon';

var DropdownItem = function DropdownItem(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      value = _ref.value,
      itemText = _ref.itemText,
      onClick = _ref.onClick,
      onKeyPress = _ref.onKeyPress,
      href = _ref.href,
      dropdownKind = _ref.dropdownKind,
      index = _ref.index,
      iconName = _ref.iconName,
      iconType = _ref.iconType,
      fieldID = _ref.fieldID,
      disabled = _ref.disabled,
      other = _objectWithoutProperties(_ref, _excluded);

  var dropdownItemClasses = cx((_cx = {
    dropdown__link: true,
    dropdown__item: true,
    'hover-highlight--primary': !disabled
  }, _defineProperty(_cx, className, className), _defineProperty(_cx, 'dropdown__item--disabled', disabled), _cx));

  var handleItemSelected = function handleItemSelected(e) {
    var info = {
      value: value,
      itemText: itemText,
      index: index,
      fieldID: fieldID,
      iconName: iconName,
      iconType: iconType
    };
    onClick(info, e);
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", _extends({}, other, {
      value: value,
      "aria-label": itemText,
      role: dropdownKind === 'select' ? 'option' : 'menuitem',
      tabIndex: -1,
      href: href,
      onClick: disabled ? null : handleItemSelected,
      onKeyPress: disabled ? null : handleItemSelected,
      className: dropdownItemClasses,
      "aria-disabled": disabled
    }), iconName ? /*#__PURE__*/React.createElement(Icon, {
      name: iconName,
      type: iconType,
      className: "marginright-sm"
    }) : null, itemText, children)
  );
};

DropdownItem.propTypes = {
  children: PropTypes.node,

  /** Value of the DropdownItem to be picked up by the parent Dropdown component */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Text of the DropdownItem to be picked up by the parent Dropdown component. This will show up as the dropdown label when selected */
  itemText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  href: PropTypes.string,
  dropdownKind: PropTypes.oneOf(['select', 'menu']),
  index: PropTypes.number,
  iconName: PropTypes.string,
  iconType: PropTypes.string,
  fieldID: PropTypes.string,
  disabled: PropTypes.bool
};
DropdownItem.defaultProps = {
  onClick: function onClick() {}
};
DropdownItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DropdownItem",
  "props": {
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": true,
      "description": "Value of the DropdownItem to be picked up by the parent Dropdown component"
    },
    "itemText": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": true,
      "description": "Text of the DropdownItem to be picked up by the parent Dropdown component. This will show up as the dropdown label when selected"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onKeyPress": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "href": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "dropdownKind": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'select'",
          "computed": false
        }, {
          "value": "'menu'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "iconName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "iconType": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "fieldID": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
export default DropdownItem;